export const PERSON_NAME_MAX = 100;

export default function personNameClean(value: string): string {
    return value.replace(/[^\p{L}\p{M}' .-]/gu, '').replace(/\s{2,}/g, ' ').slice(0, PERSON_NAME_MAX);
}
